import { womenKeys } from "../constants/query-keys";
import { womenApi } from "./women.api";

/** Seats move as guests reserve, so the cards are kept fresh for a minute only. */
const STALE_MS = 60_000;

/*
 * Plain option objects rather than react-query's `queryOptions()` helper: the
 * home page's tests stub react-query wholesale, and the banner reads these.
 */
export function womenTripsQueryOptions(lang: string) {
  return {
    queryKey: womenKeys.trips(lang),
    queryFn: () => womenApi.trips(lang),
    staleTime: STALE_MS,
  };
}

export function organiserQueryOptions(slug: string, lang: string) {
  return {
    queryKey: womenKeys.organiser(slug, lang),
    queryFn: () => womenApi.organiser(slug, lang),
    staleTime: STALE_MS,
  };
}
